import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/storage';

export const firebaseConfig = {
	apiKey: process.env.REACT_APP_API_KEY || 'AIzaSyDo2adh6dliRny9zdm85ORMTwKTPiYgpak',
	authDomain: process.env.REACT_APP_AUTH_DOMAIN || 'swarmob-staging.firebaseapp.com',
	databaseURL: process.env.REACT_APP_DATABASE_URL || 'https://swarmob-staging.firebaseio.com',
	projectId: process.env.REACT_APP_PROJECT_ID || 'swarmob-staging',
	storageBucket: process.env.REACT_APP_STORAGE_BUCKET || 'swarmob-staging.appspot.com',
	messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID || 1012925077156
};

// react-redux-firebase config
firebase.initializeApp(firebaseConfig);

export default firebase;
export const storage = firebase.storage();
